<template>
  <div>
    <hr class="a-hr-form">
    <div class="contractor__add-user">
      <h2>{{$t('form.contractor.users-list')}}:</h2>
    </div>

    <user v-for="user in users"
          :key="user.id"
          :user="user"
          :profile="profile"
          :organization="organization">
    </user>
  </div>
</template>

<script>
  import User from './ContractorUser';

  export default {
    components: {
      User
    },

    props: {
      profile: Object,
      organization: Object,
    },

    data: () => ({
      mode: 'view',
      email: undefined
    }),

    async created() {
      try {
        await this.$store.dispatch('fetchOrganizationUsers', {organizationId: this.organization.id})
      }
      catch(e) {
        console.error('unable to fetch list of users', e);
        this.globalErrorHandler(e);
      }
    },

    computed: {
      permissions() {
        return this.profile.permissions;
      },

      users() {
        const users =  this.$store.getters.organizationUsers(this.organization.id);
        return users;
      }
    },

    methods: {
    }
  }
</script>

<style scoped>

</style>
